/**
 * Environment detection utility
 * Centralized logic for determining development vs production environment
 */

/**
 * Check if the application is running in development mode
 * Uses multiple sources to detect development environment
 */
export const isDevelopment = (() => {
    // Check Vite environment variables
    if (import.meta?.env) {
        return (
            import.meta.env.MODE === 'development' ||
            import.meta.env.VITE_FlexForce_ENV === 'development' ||
            import.meta.env.DEV
        )
    }

    // Fallback to window environment (for runtime config)
    const runtimeEnv = globalThis.window?._env_
    if (runtimeEnv) {
        return runtimeEnv.REACT_APP_ENV === 'development'
    }

    // Final fallback - assume production for safety
    return false
})()

/**
 * Check if the application is running in production mode
 */
export const isProduction = !isDevelopment

export default isDevelopment
